/// <reference types="vite/client" />
import kaplay from 'kaplay';
import 'kaplay/global'; // uncomment if you want to use without the k. prefix
import { GAME_HEIGHT, GAME_WIDTH } from './constants/constants';
import { Scenes } from './constants/scenes';
import { Sounds } from './constants/sounds';
import { registerScenes } from './scenes/register-scenes';
import { getGameStateFromCheats } from './utils/get-game-state-from-cheats';
import { getQueryParams } from './utils/get-query-params';

export const k = kaplay({
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  background: '#FFFFFF',
  scale: 1,
  canvas: document.querySelector('canvas')!,
  // only have debug mode on when local
  debug: import.meta.env.DEV,
});

// register the scenes
registerScenes();

// Load the background music for the crowd scene (served from /public/music)
// This runs once on module load. Kaplay will avoid re-downloading if re-imported.
k.loadSound(Sounds.BOOGIE_PARTY, 'music/boogie-party.mp3');
k.loadSound(Sounds.MORNING, 'music/morning.mp3');

// Global background music handle (exported for other scenes to stop/change)
// this would
export const mainMusic = play(Sounds.MORNING, { loop: true, volume: 0.6, paused: true });
export const crowdMusic = play(Sounds.BOOGIE_PARTY, { loop: true, volume: 0.6, paused: true });

// Keep a handle so we don't start overlapping loops if the scene is re-entered.

// **Note** it might make sense to disable this when not in dev, but will keep
// it for the heck of it lol
const rawQueryParams = getQueryParams();

if (Object.values(rawQueryParams).length) {
  // if there are rawQueryParams, then verify if they are cheat-codes.
  // this will help test the game.

  const gameState = getGameStateFromCheats(rawQueryParams);
  debug.log('cheats activated');
  console.log('cheats activated', gameState);
  go(gameState.scene || Scenes.SPLASH, gameState);
} else {
  go(Scenes.SPLASH);
}
